import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";

export function onDeadlockHeartbeat(payload: unknown) {
  return refs.trackEvent(ANALYTIC_EVENTS.DL_HEARTBEAT, payload);
}

export function onDeadlockEnterGame(payload: unknown) {
  return refs.trackEvent(ANALYTIC_EVENTS.DL_START, payload);
}

export function onDeadlockExitGame(payload: unknown) {
  return refs.trackEvent(ANALYTIC_EVENTS.DL_END, payload);
}

export function onDeadlockMetaData(payload: unknown) {
  return refs.trackEvent(ANALYTIC_EVENTS.DL_MATCH_METADATA, payload);
}
